<!-- page specific block -->
<div class="bt b--medium-gray">
  <div class="page-margin jb-max-width center mv6 mv8-ns mv9-l">
    <jb-related-content-block>
      <!-- block title -->
      <ng-container *ngIf="!!pageBlockData.title" JbTitle>
        {{ pageBlockData.title }}
      </ng-container>
      <!-- blocks -->
      <jb-related-content-block-item
        *ngFor="
          let block of !!pageBlockData.block
            ? pageBlockData.block
            : pageBlockData.pageRelatedContent
        "
      >
        <ng-container JbTitle>
          {{ block.header }}
        </ng-container>
        <jb-related-content-block-description *ngIf="!!block.description">
          {{ block.description }}
        </jb-related-content-block-description>

        <a
          *ngIf="!!block.link && block.link.length"
          [jbSitemapLinker]="(block?.link)[0]?.href"
          [target]="block.link[0].newWindow"
          [dotLinkIcon]="block.link[0].newWindow"
          jbActionLink
          >{{ block.link[0].title }}</a
        >
      </jb-related-content-block-item>
    </jb-related-content-block>
  </div>
</div>
